import React from "react";

const InputField = ({
  label,
  name,
  type = "text",
  onChange,
  required = false,
  value = "",
  placeholder = "",
}) => {
  const handleChange = (e) => {
    // Call onChange with the value directly, not with name
    onChange(e.target.value);
  };

  return (
    <div className="space-y-2">
      {label && (
        <label htmlFor={name} className="block text-sm font-medium text-gray-700">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      {type === "textarea" ? (
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={handleChange}
          placeholder={placeholder || label}
          rows={4}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-zinc-900/15 focus:border-zinc-900 transition-colors resize-none"
        />
      ) : (
        <input
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={handleChange}
          placeholder={placeholder || label}
          required={required}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-zinc-900/15 focus:border-zinc-900 transition-colors"
        />
      )}
    </div>
  );
};

export default InputField;
